import { DefaultAvatar } from "../../../../components/ProfileSummary/index.jsx";
import React, { useState, useEffect } from "react";
import api from "../../../../services/api";
import { ANOS } from "../../../../shared/constants";
import { fmtDateFull } from "../../../../shared/utils";
import { sourceImage } from "../../../../utils/source-image";
export default function AdminAlunos(props) {
  const institutionContext = props.institutionContext;
  const [sortOrder, setSortOrder] = useState("");
  let students = props.students;
  let setStudents = props.setStudents;
  let houses = props.houses;
  let teachers = props.teachers;
  let gruposAcesso = props.gruposAcesso;
  let checkpoints = props.checkpoints;
  let setCheckpoints = props.setCheckpoints;
  let showFlash = props.showFlash;
  let editingStudent = props.editingStudent;
  let setEditingStudent = props.setEditingStudent;
  const [busca, setBusca] = useState("");
  const [buscaDebounced, setBuscaDebounced] = useState("");
  const [ultimoLoginDe, setUltimoLoginDe] = useState("");
  const [ultimoLoginAte, setUltimoLoginAte] = useState("");
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [alunosPagina, setAlunosPagina] = useState([]);
  const [totalAlunos, setTotalAlunos] = useState(0);
  const [totalPaginas, setTotalPaginas] = useState(1);
  const [carregandoLista, setCarregandoLista] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setBuscaDebounced(busca);
    }, 200);
    return () => clearTimeout(timeoutId);
  }, [busca]);
  useEffect(() => {
    setPaginaAtual(1);
  }, [buscaDebounced, ultimoLoginDe, ultimoLoginAte, sortOrder]);
  useEffect(() => {
    let ativo = true;
    (async () => {
      setCarregandoLista(true);
      try {
        const params = new URLSearchParams({
          page: String(paginaAtual),
          limit: String(20),
        });
        const termo = buscaDebounced.trim();
        if (termo) {
          params.set("q", termo);
        }
        if (ultimoLoginDe) {
          params.set("last_logged_from", ultimoLoginDe);
        }
        if (ultimoLoginAte) {
          params.set("last_logged_to", ultimoLoginAte);
        }
        if (sortOrder) {
          params.set("sort", sortOrder);
        }
        const responseData = await api.get(
          "/students?".concat(params.toString()),
          {
            dmInstitutionContext: institutionContext?.key,
          },
        );
        const data = Array.isArray(responseData.data?.data)
          ? responseData.data.data
          : [];
        const pagination = responseData.data?.pagination || {};
        if (!ativo) return;
        setAlunosPagina(data);
        setTotalAlunos(Number(pagination.total || data.length));
        setTotalPaginas(Math.max(1, Number(pagination.totalPages || 1)));
      } catch (error) {
        if (!ativo) return;
        setAlunosPagina([]);
        setTotalAlunos(0);
        setTotalPaginas(1);
      } finally {
        if (ativo) {
          setCarregandoLista(false);
        }
      }
    })();
    return () => {
      ativo = false;
    };
  }, [
    paginaAtual,
    buscaDebounced,
    ultimoLoginDe,
    ultimoLoginAte,
    reloadKey,
    sortOrder,
  ]);
  useEffect(() => {
    if (paginaAtual > totalPaginas) {
      setPaginaAtual(totalPaginas);
    }
  }, [paginaAtual, totalPaginas]);
  if (editingStudent)
    return (
      <AlunoForm
        aluno={
          "novo" === editingStudent
            ? null
            : alunosPagina.find(
                (alunosPaginaId) =>
                  Number(alunosPaginaId.id) === Number(editingStudent),
              ) ||
              students.find(
                (student) => Number(student.id) === Number(editingStudent),
              )
        }
        institutionContext={institutionContext}
        students={students}
        setStudents={setStudents}
        houses={houses}
        teachers={teachers}
        gruposAcesso={gruposAcesso}
        showFlash={showFlash}
        onClose={() => {
          setEditingStudent(null);
          setReloadKey((resultado) => resultado + 1);
        }}
      />
    );
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 12,
          flexWrap: "wrap",
          gap: 8,
        }}
      >
        <div
          style={{
            fontSize: 14,
            fontWeight: 700,
            color: "#FFF",
          }}
        >
          {totalAlunos}
          {" alunos"}
        </div>
        <button className={"btn"} onClick={() => setEditingStudent("novo")}>
          {"+ Novo Aluno"}
        </button>
      </div>
      <div
        style={{
          display: "flex",
          gap: 8,
          marginBottom: 10,
          flexWrap: "wrap",
          alignItems: "flex-end",
        }}
      >
        <input
          className={"inp"}
          style={{
            flex: 1,
            minWidth: 200,
          }}
          value={busca}
          onChange={(event) => setBusca(event.target.value)}
          placeholder={"Buscar por nome, usuario, escola ou ano"}
          aria-label={"Buscar alunos"}
        />
        <div>
          <label
            style={{
              display: "block",
              fontSize: 11,
              color: "#6B8590",
              marginBottom: 3,
            }}
          >
            {"Último acesso de"}
          </label>
          <input
            type={"date"}
            className={"inp"}
            value={ultimoLoginDe}
            onChange={(event) => setUltimoLoginDe(event.target.value)}
            aria-label={"Ultimo acesso a partir de"}
          />
        </div>
        <div>
          <label
            style={{
              display: "block",
              fontSize: 11,
              color: "#6B8590",
              marginBottom: 3,
            }}
          >
            {"até"}
          </label>
          <input
            type={"date"}
            className={"inp"}
            value={ultimoLoginAte}
            onChange={(event) => setUltimoLoginAte(event.target.value)}
            aria-label={"Ultimo acesso ate"}
          />
        </div>
        {(ultimoLoginDe || ultimoLoginAte) && (
          <button
            type={"button"}
            className={"btn bg bs"}
            onClick={() => {
              setUltimoLoginDe("");
              setUltimoLoginAte("");
            }}
          >
            {"Limpar período"}
          </button>
        )}
      </div>
      <div
        style={{
          overflowX: "auto",
        }}
      >
        <table className={"tbl"}>
          <thead>
            <tr>
              <th>{"Nome"}</th>
              <th>{"Login"}</th>
              <th>{"Instituição"}</th>
              <th>{"Escola/Ano"}</th>
              <th>{"Status"}</th>
              <th
                aria-sort={
                  sortOrder === "last_logged_desc"
                    ? "descending"
                    : sortOrder === "last_logged_asc"
                      ? "ascending"
                      : "none"
                }
              >
                <button
                  type={"button"}
                  style={{
                    border: 0,
                    padding: 0,
                    background: "none",
                    font: "inherit",
                    color: "inherit",
                    cursor: "pointer",
                  }}
                  aria-label={"Ordenar pelo último acesso"}
                  onClick={() =>
                    setSortOrder((resultado) =>
                      resultado === ""
                        ? "last_logged_desc"
                        : resultado === "last_logged_desc"
                          ? "last_logged_asc"
                          : "",
                    )
                  }
                >
                  {"Último acesso " +
                    (sortOrder === "last_logged_desc"
                      ? "↓"
                      : sortOrder === "last_logged_asc"
                        ? "↑"
                        : "↕")}
                </button>
              </th>
              <th />
            </tr>
          </thead>
          <tbody>
            {alunosPagina.map((alunosPaginaCasa_id) => {
              const house = houses.find(
                (houseId) => houseId.id === alunosPaginaCasa_id.casa_id,
              );
              return (
                <tr key={alunosPaginaCasa_id.id}>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 7,
                      }}
                    >
                      <div
                        style={{
                          width: 24,
                          height: 24,
                          borderRadius: "50%",
                          background: "#1F4754",
                          color: "#FFF",
                          display: "grid",
                          placeItems: "center",
                          fontWeight: 700,
                          fontSize: 10,
                          ...(alunosPaginaCasa_id.foto
                            ? {
                                backgroundImage: "url(".concat(
                                  sourceImage(alunosPaginaCasa_id.foto),
                                  ")",
                                ),
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                              }
                            : {}),
                        }}
                      >
                        {!alunosPaginaCasa_id.foto && DefaultAvatar()}
                      </div>
                      <strong>
                        {institutionContext?.onStudentRecord ? (
                          <button
                            type={"button"}
                            style={{
                              padding: 0,
                              border: 0,
                              background: "transparent",
                              font: "inherit",
                              color: "inherit",
                              textAlign: "left",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              institutionContext.onStudentRecord(
                                alunosPaginaCasa_id.id,
                              )
                            }
                          >
                            {alunosPaginaCasa_id.nome}
                          </button>
                        ) : (
                          alunosPaginaCasa_id.nome
                        )}
                      </strong>
                    </div>
                  </td>
                  <td>
                    <code
                      style={{
                        fontSize: 11,
                        color: "#6B8590",
                      }}
                    >
                      {alunosPaginaCasa_id.usuario}
                    </code>
                  </td>
                  <td>
                    {house ? (
                      <span
                        style={{
                          color: house.cor,
                          fontWeight: 700,
                        }}
                      >
                        {house.nome}
                      </span>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td
                    style={{
                      fontSize: 11,
                      color: "#6B8590",
                    }}
                  >
                    {alunosPaginaCasa_id.escola || "-"}
                    {alunosPaginaCasa_id.ano && (
                      <div>{alunosPaginaCasa_id.ano}</div>
                    )}
                  </td>
                  <td>
                    <span
                      className={"bst ".concat(
                        alunosPaginaCasa_id.ativo ? "bon" : "bof",
                      )}
                    >
                      {alunosPaginaCasa_id.ativo ? "Ativo" : "Inativo"}
                    </span>
                  </td>
                  <td
                    style={{
                      fontSize: 11,
                      color: "#6B8590",
                    }}
                  >
                    {alunosPaginaCasa_id.last_logged
                      ? fmtDateFull(alunosPaginaCasa_id.last_logged)
                      : "-"}
                  </td>
                  <td
                    style={{
                      textAlign: "right",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <button
                      className={"btn bg bs"}
                      style={{
                        marginRight: 4,
                      }}
                      onClick={() => setEditingStudent(alunosPaginaCasa_id.id)}
                    >
                      {"Editar"}
                    </button>
                    {!institutionContext && (
                      <button
                        className={"btn bd bs"}
                        onClick={() =>
                          (async (item) => {
                            try {
                              await api.delete("/students?id=".concat(item.id));
                              setStudents(
                                students.filter(
                                  (student) => student.id !== item.id,
                                ),
                              );
                              setCheckpoints(
                                checkpoints.filter(
                                  (checkpoint) =>
                                    checkpoint.aluno_id !== item.id,
                                ),
                              );
                              setReloadKey((resultado) => resultado + 1);
                              showFlash("Excluido.");
                            } catch (err) {
                              showFlash(
                                err.response?.data?.message ||
                                  "Nao foi possivel excluir o aluno.",
                                "er",
                              );
                            }
                          })(alunosPaginaCasa_id)
                        }
                      >
                        {"X"}
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}
            {0 === alunosPagina.length && (
              <tr>
                <td
                  colSpan={7}
                  style={{
                    textAlign: "center",
                    padding: "16px 8px",
                    color: "#6B8590",
                  }}
                >
                  {"Nenhum aluno encontrado para a busca."}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {totalAlunos > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: 10,
            gap: 8,
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              fontSize: 12,
              color: "#6B8590",
            }}
          >
            {"Exibindo "}
            {20 * (paginaAtual - 1) + 1}
            {"-"}
            {Math.min(20 * paginaAtual, totalAlunos)}
            {" de"} {totalAlunos}
          </div>
          <div
            style={{
              display: "flex",
              gap: 6,
              alignItems: "center",
            }}
          >
            <button
              className={"btn bg bs"}
              disabled={paginaAtual <= 1 || carregandoLista}
              onClick={() =>
                setPaginaAtual((resultado) => Math.max(1, resultado - 1))
              }
            >
              {"Anterior"}
            </button>
            <span
              style={{
                fontSize: 12,
                color: "#FFF",
                minWidth: 64,
                textAlign: "center",
              }}
            >
              {paginaAtual}
              {"/"}
              {totalPaginas}
            </span>
            <button
              className={"btn bg bs"}
              disabled={paginaAtual >= totalPaginas || carregandoLista}
              onClick={() =>
                setPaginaAtual((resultado) =>
                  Math.min(totalPaginas, resultado + 1),
                )
              }
            >
              {"Proxima"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
function AlunoForm(props) {
  const institutionContext = props.institutionContext;
  let aluno = props.aluno;
  let students = props.students;
  let setStudents = props.setStudents;
  let houses = props.houses;
  let teachers = props.teachers;
  let gruposAcesso = props.gruposAcesso;
  let showFlash = props.showFlash;
  let onClose = props.onClose;
  const [form, setForm] = useState(
    aluno
      ? {
          ...aluno,
          senha: "",
        }
      : {
          nome: "",
          usuario: "",
          senha: "",
          casa_id: institutionContext?.institutionId || 0,
          professor_id: 0,
          grupo_acesso_id: 0,
          ativo: true,
          escola: "",
          ano: "",
          objetivo: "",
          telefone: "",
          bio: "",
          foto: null,
        },
  );
  const [foto, setFoto] = useState(aluno?.foto || null);
  return (
    <div>
      <div
        style={{
          display: "flex",
          gap: 9,
          marginBottom: 11,
        }}
      >
        <button onClick={onClose} className={"btn bg bs"}>
          {"Voltar"}
        </button>
        <div
          style={{
            fontWeight: 700,
            color: "#FFF",
            fontSize: 14,
          }}
        >
          {aluno ? "Editar" : "Novo"}
          {" Aluno"}
        </div>
      </div>
      <form
        onSubmit={async (event) => {
          event.preventDefault();
          if (!form.nome.trim() || !form.usuario.trim()) {
            showFlash("Nome e usuario obrigatorios.", "er");
            return;
          }
          if (
            students.some(
              (student) =>
                student.usuario === form.usuario.trim() &&
                student.id !== aluno?.id,
            )
          ) {
            showFlash("Usuario já existe.", "er");
            return;
          }
          if (!Number(form.casa_id)) {
            showFlash("Selecione a instituição.", "er");
            return;
          }
          const dados = {
            ...form,
            usuario: form.usuario.trim(),
            nome: form.nome.trim(),
            foto,
            senha: form.senha || "",
            casa_id: Number(form.casa_id) || null,
            professor_id: Number(form.professor_id) || null,
            grupo_acesso_id: Number(form.grupo_acesso_id) || null,
          };
          try {
            const responseData2 = aluno
              ? await api.put("/students?id=".concat(aluno.id), dados, {
                  dmInstitutionContext: institutionContext?.key,
                })
              : await api.post("/students", dados, {
                  dmInstitutionContext: institutionContext?.key,
                });
            const saved = responseData2.data?.data ?? responseData2.data;
            if (aluno) {
              setStudents(
                students.map((student) =>
                  student.id === aluno.id ? saved : student,
                ),
              );
              showFlash("Atualizado.");
            } else {
              setStudents([...students, saved]);
              showFlash("Cadastrado.");
            }
            onClose();
          } catch (err) {
            showFlash(
              err.response?.data?.message || "Nao foi possivel salvar o aluno.",
              "er",
            );
          }
        }}
        className={"fc"}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            marginBottom: 14,
          }}
        >
          <div
            className={"pa"}
            style={{
              width: 58,
              height: 58,
              fontSize: 20,
              ...(foto
                ? {
                    backgroundImage: "url(".concat(sourceImage(foto), ")"),
                  }
                : {}),
            }}
          >
            {!foto && DefaultAvatar()}
          </div>
          <div
            style={{
              flex: 1,
            }}
          >
            <label
              style={{
                fontSize: 12,
                fontWeight: 700,
                color: "#1F4754",
                display: "block",
                marginBottom: 5,
              }}
            >
              {"Foto"}
            </label>
            <input
              type={"file"}
              accept={"image/*"}
              onChange={(event) => {
                const item = event.target.files[0];
                if (!item) return;
                const instance = new FileReader();
                instance.onload = (eventTarget) =>
                  setFoto(eventTarget.target.result);
                instance.readAsDataURL(item);
              }}
              className={"inp"}
            />
          </div>
        </div>
        <div className={"fr"}>
          <div className={"fg"}>
            <label>{"Nome *"}</label>
            <input
              className={"inp"}
              value={form.nome}
              onChange={(event) =>
                setForm({
                  ...form,
                  nome: event.target.value,
                })
              }
              required={true}
            />
          </div>
          <div className={"fg"}>
            <label>{"E-mail *"}</label>
            <input
              type={aluno ? "text" : "email"}
              maxLength={254}
              className={"inp"}
              value={form.usuario}
              onChange={(event) =>
                setForm({
                  ...form,
                  usuario: event.target.value.toLowerCase().replace(/\s+/g, ""),
                })
              }
              required={true}
            />
          </div>
        </div>
        <div className={"fr"}>
          <div className={"fg"}>
            <label>{"Senha"}</label>
            <input
              type={"password"}
              minLength={6}
              maxLength={72}
              required={!aluno}
              className={"inp"}
              value={form.senha}
              onChange={(event) =>
                setForm({
                  ...form,
                  senha: event.target.value,
                })
              }
              placeholder={
                aluno ? "Deixe vazio para manter" : "Mínimo de 6 caracteres"
              }
            />
          </div>
          <div className={"fg"}>
            <label>{"Telefone"}</label>
            <input
              className={"inp"}
              value={form.telefone || ""}
              onChange={(event) =>
                setForm({
                  ...form,
                  telefone: event.target.value,
                })
              }
            />
          </div>
        </div>
        <div className={"fr"}>
          <div className={"fg"}>
            <label>{"Escola"}</label>
            <input
              className={"inp"}
              value={form.escola || ""}
              onChange={(event) =>
                setForm({
                  ...form,
                  escola: event.target.value,
                })
              }
            />
          </div>
          <div className={"fg"}>
            <label>{"Ano"}</label>
            <select
              className={"sel"}
              value={form.ano || ""}
              onChange={(event) =>
                setForm({
                  ...form,
                  ano: event.target.value,
                })
              }
            >
              <option value={""}>{"-"}</option>
              {form.ano && !ANOS.includes(form.ano) && (
                <option value={form.ano}>{form.ano}</option>
              )}
              {ANOS.map((ano) => (
                <option value={ano} key={ano}>
                  {ano}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className={"fg"}>
          <label>{"Objetivo"}</label>
          <input
            className={"inp"}
            value={form.objetivo || ""}
            onChange={(event) =>
              setForm({
                ...form,
                objetivo: event.target.value,
              })
            }
            placeholder={"Ex: Medicina USP"}
          />
        </div>
        <div className={"fr"}>
          <div className={"fg"}>
            <label>{"Instituição"}</label>
            <select
              className={"sel"}
              required={true}
              disabled={!!institutionContext && !form.id}
              value={form.casa_id || ""}
              onChange={(event) =>
                setForm({
                  ...form,
                  casa_id: Number(event.target.value),
                })
              }
            >
              <option value={""} disabled={true}>
                {"Selecione a instituição"}
              </option>
              {houses.map((house) => (
                <option value={house.id} key={house.id}>
                  {house.nome}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className={"fg"}>
          <label>{"Grupo de Acesso"}</label>
          <select
            className={"sel"}
            value={form.grupo_acesso_id || 0}
            onChange={(event) =>
              setForm({
                ...form,
                grupo_acesso_id: Number(event.target.value),
              })
            }
          >
            <option value={0}>{"Acesso total (sem grupo)"}</option>
            {(gruposAcesso || []).map((item) => (
              <option value={item.id} key={item.id}>
                {item.nome}
                {item.ativo ? "" : " (inativo)"}
              </option>
            ))}
          </select>
        </div>
        <div className={"fg"}>
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              textTransform: "none",
              letterSpacing: "normal",
              fontSize: 13,
              color: "#1F4754",
            }}
          >
            <input
              type={"checkbox"}
              checked={form.ativo}
              onChange={(event) =>
                setForm({
                  ...form,
                  ativo: event.target.checked,
                })
              }
            />{" "}
            {"Ativo"}
          </label>
        </div>
        <div className={"fg"}>
          <label>{"Bio"}</label>
          <textarea
            className={"tea"}
            value={form.bio || ""}
            onChange={(event) =>
              setForm({
                ...form,
                bio: event.target.value,
              })
            }
            style={{
              minHeight: 50,
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            gap: 8,
          }}
        >
          <button type={"submit"} className={"btn"}>
            {aluno ? "Atualizar" : "Cadastrar"}
          </button>
          <button type={"button"} className={"btn bg"} onClick={onClose}>
            {"Cancelar"}
          </button>
        </div>
      </form>
    </div>
  );
}
export { AdminAlunos };
